/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DigitizingMelcoModelsError,
    DigitizingMelcoModelsErrorFromJSON,
    DigitizingMelcoModelsErrorToJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItemFromJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItemToJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItemToJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItemFromJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItemToJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItemFromJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItemToJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItemFromJSON,
    DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItemToJSON,
} from '../models';

/**
 * 
 */
export class DigitizingDefaultsApi extends runtime.BaseAPI {

    /**
     */
    async digitizingGetColorsRaw(): Promise<runtime.ApiResponse<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitizing/defaults/colors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetColors(): Promise<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem> {
        const response = await this.digitizingGetColorsRaw();
        return await response.value();
    }

    /**
     */
    async digitizingGetDeliveryOptionsRaw(): Promise<runtime.ApiResponse<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitizing/defaults/deliveryoptions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetDeliveryOptions(): Promise<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingDeliveryOptionListItem> {
        const response = await this.digitizingGetDeliveryOptionsRaw();
        return await response.value();
    }

    /**
     */
    async digitizingGetGarmentTypesRaw(): Promise<runtime.ApiResponse<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitizing/defaults/garmenttypes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetGarmentTypes(): Promise<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingGarmentTypeListItem> {
        const response = await this.digitizingGetGarmentTypesRaw();
        return await response.value();
    }

    /**
     */
    async digitizingGetOutputFormatsRaw(): Promise<runtime.ApiResponse<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitizing/defaults/outputformats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetOutputFormats(): Promise<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingOutputFormatListItem> {
        const response = await this.digitizingGetOutputFormatsRaw();
        return await response.value();
    }

    /**
     */
    async digitizingGetPositionsRaw(): Promise<runtime.ApiResponse<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitizing/defaults/positions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetPositions(): Promise<DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingPositionListItem> {
        const response = await this.digitizingGetPositionsRaw();
        return await response.value();
    }

}
